import React, {useState} from "react";
import Dots from "./Dots";
import "./slider.scss";

import img_1 from "../../../assets/images/onboarding_1.png";
import img_2 from "../../../assets/images/onboarding_2.png";
import img_3 from "../../../assets/images/onboarding_3.png";
import img_4 from "../../../assets/images/onboarding_4.png";
import img_5 from "../../../assets/images/onboarding_5.png";

const slides = [img_1, img_2, img_3, img_4, img_5];

const Slider = (props) => {
    const getWidth = () => window.innerWidth;

    const [state, setState] = useState({
        activeIndex: 0,
        translate: 0,
        transition: 0.45,
    });

    const {translate, transition, activeIndex} = state;

    const nextSlide = () => {
        if (activeIndex === slides.length - 1) {
            return;
        }

        setState({
            ...state,
            activeIndex: activeIndex + 1,
            translate: (activeIndex + 1) * getWidth(),
        });
    };

    const prevSlide = () => {
        if (activeIndex === 0) {
            return;
        }

        setState({
            ...state,
            activeIndex: activeIndex - 1,
            translate: (activeIndex - 1) * getWidth(),
        });
    };

    const handleFinish = () => {
        props.closeModal(true);
    };

    const slideContent = () => {
        let contentTitle = "";
        let contentText = "";

        switch (activeIndex) {
            case 0:
                contentTitle = "Welcome to My Dashboards";
                contentText =
                    "Gluware dashboards provide a central place to monitor device data and activity";
                break;

            case 1:
                contentTitle = "Dashboard Library";
                // eslint-disable-next-line max-len
                contentText =
                    "Your Dashboard Library is the place to access and organize your favorites and other dashboards";
                break;

            case 2:
                contentTitle = "Create a new dashboard";
                contentText = "Create a dashboard and share it with others in your organizations";
                break;

            case 3:
                contentTitle = "Add widgets to your dashboard";
                contentText =
                    "Choose from a variety of widgets and configure each one with unique functionality";
                break;

            case 4:
                contentTitle = "The running dashboard";
                contentText = "Follow updates on your favorite dashboards throughout the day";
                break;

            default:
                contentTitle = "";
                contentText = "";
        }

        return (
            <>
                <div className="glu-slide__text-content">
                    <h1>{contentTitle}</h1>
                    <p>{contentText}</p>
                </div>
            </>
        );
    };

    return (
        <div className="glu-slider">
            <div className="glu-flex glu-flex-justify-end">
                <button
                    aria-label="close"
                    type="button"
                    className="glu-btn-link g-icon g-icon-close"
                    onClick={props.closeModal}
                />
            </div>
            <div
                className="glu-slider-content"
                style={{
                    width: getWidth() * slides.length,
                    transform: `translateX(-${translate}px)`,
                    transition: `transform ease-out ${transition}s`,
                }}
            >
                {slides.map((imageUrl) => (
                    <div key={imageUrl} className="glu-slide">
                        <img src={imageUrl} alt="Slide" />
                    </div>
                ))}
            </div>

            <Dots slides={slides} activeIndex={activeIndex} />

            {slideContent()}

            <div className="buttons glu-slider-button-container">
                {activeIndex === 0 ? (
                    <button
                        className="glu-slider-button-container__button glu-btn glu-btn--secondary"
                        onClick={props.closeModal}
                    >
                        Skip
                    </button>
                ) : (
                    <button
                        className="glu-slider-button-container__button glu-btn glu-btn--secondary"
                        onClick={prevSlide}
                    >
                        Previous
                    </button>
                )}

                {activeIndex === 4 ? (
                    <button
                        className="glu-slider-button-container__button glu-btn glu-btn--primary"
                        onClick={handleFinish}
                    >
                        Finish
                    </button>
                ) : (
                    <button
                        className="glu-slider-button-container__button glu-btn glu-btn--primary"
                        onClick={nextSlide}
                    >
                        Next
                    </button>
                )}
            </div>
        </div>
    );
};

export default Slider;
